import types from './types';
import { Dispatch } from "redux";

export interface BreadcrumbRoute {
  pathname: string,
  Component: any,
  breadcrumbs: any[]
}

//updates breadcrumb and return the new breadcrumb state
export const updateBreadcrumb = (payload: BreadcrumbRoute) => (dispatch: Dispatch<any>, getState: any) => {

  dispatch({
    type: types.UPDATE_BREADCRUMB,
    payload
  });

  return getState().persistedReducer.breadcrumb;
}